import { render, staticRenderFns } from "./AboutHero.vue?vue&type=template&id=728ec952&scoped=true&"
import script from "./AboutHero.vue?vue&type=script&lang=js&"
export * from "./AboutHero.vue?vue&type=script&lang=js&"
import style0 from "./AboutHero.vue?vue&type=style&index=0&id=728ec952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ec952",
  null
  
)

export default component.exports